import { render } from "./TopupCompleted.vue?vue&type=template&id=246624d2&scoped=true"
import script from "./TopupCompleted.vue?vue&type=script&lang=js"
export * from "./TopupCompleted.vue?vue&type=script&lang=js"

import "./TopupCompleted.vue?vue&type=style&index=0&id=246624d2&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-246624d2"]])

export default __exports__